// apiKeysService.js
//
// Thin async wrappers over FetchAPI for the master-system API key endpoints
// (MasterApiKeyController). Colocated with the panel because this state is
// single-screen; mirrors the one-line style of helpers/fakebackend_helper.js.
//
// FetchAPI auto-attaches `Authorization: Bearer <authUser.token>` from
// localStorage, sends a JSON body for non-GET (so the DELETE carries its
// array), and returns `undefined` on a 401 — callers must null-check.
//
// NOTE: never put a lowercase `id` on a create item — FetchAPI would append
// `/<id>` to the POST url and break the /masterapikey/my/create route.

import { FetchAPI } from "../../../../helpers/APIdata/fetchAPI";

// GET /masterapikey/my/list -> { status, message, masterapikey_list: [...] }
export const listMyApiKeys = () => FetchAPI("/masterapikey/my/list", "GET");

// POST /masterapikey/my/create
// labelArray: [{ Label: "..." }] -> response.masterapikey_list[0].ApiKey is the
// FULL plaintext key, shown to the user exactly once.
export const createMyApiKeys = (labelArray) =>
  FetchAPI("/masterapikey/my/create", "POST", labelArray);

// GET /masterapikey/my/data/{id} -> { masterapikey_data:[...], authcapability_id_list:[ids] }
export const getMyApiKeyData = (id) =>
  FetchAPI("/masterapikey/my/data/" + id, "GET");

// PUT /masterapikey/my/update
// items: [{ Id, FlagAllAccess: 0|1, AuthCapabilityIds: [id, ...] }]
// Capital `Id` is safe (only a lowercase `id` triggers FetchAPI's url append).
export const updateMyApiKeys = (items) =>
  FetchAPI("/masterapikey/my/update", "PUT", items);

// DELETE /masterapikey/my/void
// idArray: [Id, Id, ...] of keys to void (soft-delete).
export const voidMyApiKeys = (idArray) =>
  FetchAPI("/masterapikey/my/void", "DELETE", idArray);

// GET /mastersecurityauthcapability/list -> { mastersecurityauthcapability_list:[...] }
// The pool of auth capabilities a restricted key can be scoped to.
export const listAuthCapabilities = () =>
  FetchAPI("/mastersecurityauthcapability/list", "GET");
